import Pavlova from "../img/pavlova.png";
import markerBasique from "../img/markerBasique.png";
import viennoiserie from "../img/croissant.png";
import babka from "../img/babka.png";
import brioche from "../img/brioche.png";
import choux from "../img/choux.png";
import churros from "../img/churros.png";
import cookies from "../img/cookies.png";
import eclairs from "../img/eclairs.png";
import kouignaman from "../img/kouignaman.png";
import chausson from "../img/chausson.png";
import madeleine from "../img/madeleine.png";
import painChocolat from "../img/painChocolat.png";
import cheesecake from "../img/cheesecake.png";
import montblanc from "../img/montblanc.png";
import galette from "../img/galette.png";
import macaron from "../img/macaron.png";
import medovic from "../img/medovic.png";
import cinnamon from "../img/cinnamon.png";
import parisBrest from "../img/parisBrest.png";
import stHonore from "../img/st-honore.png";
import tartes from "../img/tartes.png";
import merveilleux from "../img/merveilleux.png";
import oriental from "../img/oriental.png";
import flan from "../img/flan.png";
import millefeuilles from "../img/millefeuilles.png";
import glace from "../img/glace.png";
import autres from "../img/autres.png";

import markerShadow from "../img/markerShadow.png";
import roundShadow from "../img/roundShadow.png";

import L from 'leaflet';

export const IconAutres = new L.Icon({
    iconUrl: autres,
    iconRetinaUrl: autres,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [25, 41],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconMadeleine = new L.Icon({
    iconUrl: madeleine,
    iconRetinaUrl: madeleine,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 32],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconPainChocolat = new L.Icon({
    iconUrl: painChocolat,
    iconRetinaUrl: painChocolat,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 32],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconMontBlanc = new L.Icon({
    iconUrl: montblanc,
    iconRetinaUrl: montblanc,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 32],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconCheesecake = new L.Icon({
    iconUrl: cheesecake,
    iconRetinaUrl: cheesecake,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 32],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconCinnamon = new L.Icon({
    iconUrl: cinnamon,
    iconRetinaUrl: cinnamon,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 32],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconKouignaman = new L.Icon({
    iconUrl: kouignaman,
    iconRetinaUrl: kouignaman,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 32],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconGlace = new L.Icon({
    iconUrl: glace,
    iconRetinaUrl: glace,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 32],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconMillefeuilles = new L.Icon({
    iconUrl: millefeuilles,
    iconRetinaUrl: millefeuilles,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 38],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconFlan = new L.Icon({
    iconUrl: flan,
    iconRetinaUrl: flan,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [27, 35],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconOriental = new L.Icon({
    iconUrl: oriental,
    iconRetinaUrl: oriental,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [29, 37],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconMerveilleux = new L.Icon({
    iconUrl: merveilleux,
    iconRetinaUrl: merveilleux,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 30],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconTartes = new L.Icon({
    iconUrl: tartes,
    iconRetinaUrl: tartes,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 35],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconStHonore = new L.Icon({
    iconUrl: stHonore,
    iconRetinaUrl: stHonore,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 37],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconParisBrest = new L.Icon({
    iconUrl: parisBrest,
    iconRetinaUrl: parisBrest,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 39],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconMedovic = new L.Icon({
    iconUrl: medovic,
    iconRetinaUrl: medovic,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 33],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconMacaron = new L.Icon({
    iconUrl: macaron,
    iconRetinaUrl: macaron,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [27, 37],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconGalette = new L.Icon({
    iconUrl: galette,
    iconRetinaUrl: galette,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [27, 33],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconEclairs = new L.Icon({
    iconUrl: eclairs,
    iconRetinaUrl: eclairs,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [27, 31],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconChausson = new L.Icon({
    iconUrl: chausson,
    iconRetinaUrl: chausson,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [27, 31],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconCookies = new L.Icon({
    iconUrl: cookies,
    iconRetinaUrl: cookies,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 40],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconChurros = new L.Icon({
    iconUrl: churros,
    iconRetinaUrl: churros,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [29, 31],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconChoux = new L.Icon({
    iconUrl: choux,
    iconRetinaUrl: choux,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 38],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconBrioche = new L.Icon({
    iconUrl: brioche,
    iconRetinaUrl: brioche,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 35],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconBabka = new L.Icon({
    iconUrl: babka,
    iconRetinaUrl: babka,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 35],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconPavlova = new L.Icon({
    iconUrl: Pavlova,
    iconRetinaUrl: Pavlova,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 41],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconViennoiserie = new L.Icon({
    iconUrl: viennoiserie,
    iconRetinaUrl: viennoiserie,
    shadowUrl: roundShadow,
    shadowSize: [50, 41],
    shadowAnchor: [28, 40],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});

export const IconDefault = new L.Icon({
    iconUrl: markerBasique,
    iconRetinaUrl: markerBasique,
    shadowUrl: markerShadow,
    shadowSize: [50, 41],
    shadowAnchor: [25, 41],
    popupAnchor: [-13, -41],
    iconSize: new L.Point(25, 41),
    iconAnchor: [25, 41],
    className: 'leaflet-div-icon'
});
